/* cart-drawer.js (THEME version) — universal mini-cart, server-backed.
   Same canon UI as the static-site drawer (FAB + slide-in), but the cart is
   Shopify's own: reads /cart.js, adds via /cart/add.js, qty via /cart/change.js,
   checkout is native /checkout. No localStorage.
   API: LWA_CARTDRAWER.add(variantId, qty) -> Promise
        LWA_CARTDRAWER.open() / .refresh() */
(function(){
  if (window.LWA_CARTDRAWER) return;
  const money = c => '$' + (c / 100).toFixed(2);

  const css = document.createElement('style');
  css.textContent = `
  .lwacart-fab{position:fixed;right:1.1rem;bottom:1.1rem;z-index:70;display:flex;align-items:center;gap:.5rem;background:#0B0B0B;color:#FBFAF7;border:1px solid #B3893F;border-radius:2px;padding:.7rem 1.2rem;font:700 .72rem Manrope,sans-serif;letter-spacing:.12em;text-transform:uppercase;cursor:pointer;box-shadow:0 12px 34px -12px rgba(11,11,11,.45);transition:transform .25s}
  .lwacart-fab:hover{transform:translateY(-2px)}
  .lwacart-fab b{background:#B3893F;color:#0B0B0B;border-radius:2px;min-width:1.3rem;height:1.3rem;display:inline-flex;align-items:center;justify-content:center;font-size:.7rem}
  .lwacart-fab.hide{display:none}
  .lwacart-scrim{position:fixed;inset:0;background:rgba(11,11,11,.45);z-index:80;opacity:0;pointer-events:none;transition:opacity .3s}
  .lwacart-scrim.open{opacity:1;pointer-events:auto}
  .lwacart{position:fixed;top:0;right:0;bottom:0;width:min(400px,92vw);background:#FBFAF7;z-index:81;transform:translateX(102%);transition:transform .4s cubic-bezier(.22,1,.36,1);display:flex;flex-direction:column;border-left:1px solid rgba(11,11,11,.15)}
  .lwacart.open{transform:none}
  .lwacart-head{display:flex;justify-content:space-between;align-items:center;padding:1.2rem 1.4rem;border-bottom:1px solid rgba(11,11,11,.15)}
  .lwacart-head h3{font-family:Fraunces,serif;font-weight:400;font-size:1.3rem;margin:0}
  .lwacart-head button{background:none;border:0;font-size:1.3rem;cursor:pointer;color:#0B0B0B}
  .lwacart-body{flex:1;overflow-y:auto;padding:1rem 1.4rem}
  .lwacart-empty{font-family:Fraunces,serif;font-style:italic;color:#8C8C88;text-align:center;padding:3rem 0;font-size:1.05rem}
  .lwacart-item{display:flex;gap:.9rem;padding:.9rem 0;border-bottom:1px solid rgba(11,11,11,.08);align-items:center}
  .lwacart-item img{width:52px;height:64px;object-fit:cover;border:1px solid rgba(11,11,11,.12)}
  .lwacart-item .t{font-size:.76rem;font-weight:700;line-height:1.3;flex:1}
  .lwacart-item .v{font-size:.66rem;color:#8C8C88;font-weight:600}
  .lwacart-item .p{font-size:.8rem;font-weight:800;white-space:nowrap}
  .lwacart-qty{display:flex;align-items:center;gap:.35rem;margin-top:.3rem}
  .lwacart-qty button{width:1.35rem;height:1.35rem;border:1px solid rgba(11,11,11,.2);background:#fff;border-radius:2px;font-size:.75rem;cursor:pointer;line-height:1}
  .lwacart-rm{background:none;border:0;color:#8C8C88;font-size:.62rem;letter-spacing:.1em;text-transform:uppercase;cursor:pointer;padding:0;margin-left:.4rem}
  .lwacart-rm:hover{color:#B33A2B}
  .lwacart-foot{border-top:1px solid rgba(11,11,11,.15);padding:1.2rem 1.4rem}
  .lwacart-sub{display:flex;justify-content:space-between;font-size:.85rem;font-weight:700;margin-bottom:.9rem}
  .lwacart-sub b{font-family:Fraunces,serif;font-size:1.25rem}
  .lwacart-ck{display:block;text-align:center;background:linear-gradient(135deg,#D6B26B,#B3893F);color:#0B0B0B;font-weight:800;font-size:.74rem;letter-spacing:.14em;text-transform:uppercase;padding:.95rem;border-radius:2px;text-decoration:none}
  .lwacart-edit{display:block;text-align:center;font-size:.68rem;color:#8C8C88;margin-top:.7rem;letter-spacing:.06em}
  [data-theme=dark] .lwacart{background:#1C1C1A;color:#F2F0EA;border-left-color:rgba(242,240,234,.16)}
  [data-theme=dark] .lwacart-head{border-bottom-color:rgba(242,240,234,.16)}
  [data-theme=dark] .lwacart-head button{color:#F2F0EA}
  [data-theme=dark] .lwacart-empty{color:#8A8781}
  [data-theme=dark] .lwacart-item{border-bottom-color:rgba(242,240,234,.1)}
  [data-theme=dark] .lwacart-item img{border-color:rgba(242,240,234,.18)}
  [data-theme=dark] .lwacart-qty button{background:#141412;border-color:rgba(242,240,234,.22);color:#F2F0EA}
  [data-theme=dark] .lwacart-foot{border-top-color:rgba(242,240,234,.16)}`;
  document.head.appendChild(css);

  const fab = document.createElement('button');
  fab.className = 'lwacart-fab'; fab.setAttribute('aria-label','Open cart');
  const scrim = document.createElement('div'); scrim.className = 'lwacart-scrim';
  const dr = document.createElement('aside'); dr.className = 'lwacart'; dr.setAttribute('aria-label','Shopping cart');
  document.body.append(fab, scrim, dr);

  let CART = { items: [], item_count: 0, total_price: 0 };

  const api = (url, body) => fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(r => { if (!r.ok) throw 0; return r.json(); });

  function render(){
    const n = CART.item_count || 0;
    fab.innerHTML = 'Cart <b>' + n + '</b>';
    fab.classList.toggle('hide', n === 0 && !dr.classList.contains('open'));
    const items = CART.items || [];
    dr.innerHTML = `
      <div class="lwacart-head"><h3>Your cart</h3><button aria-label="Close" data-x>✕</button></div>
      <div class="lwacart-body">${items.length ? items.map((i, ix) => `
        <div class="lwacart-item">
          ${i.image ? `<img src="${i.image}&width=120" alt="">` : ''}
          <div><div class="t">${i.product_title}</div>
            ${i.variant_title ? `<div class="v">${i.variant_title}</div>` : ''}
            <div class="lwacart-qty">
              <button data-dec="${ix}" aria-label="Decrease">−</button><span>${i.quantity}</span><button data-inc="${ix}" aria-label="Increase">+</button>
              <button class="lwacart-rm" data-rm="${ix}">remove</button>
            </div></div>
          <div class="p">${money(i.final_line_price)}</div>
        </div>`).join('') : '<p class="lwacart-empty">Nothing here yet — the walls are waiting.</p>'}
      </div>
      ${items.length ? `<div class="lwacart-foot">
        <div class="lwacart-sub"><span>Subtotal</span><b>${money(CART.total_price)}</b></div>
        <a class="lwacart-ck" href="/checkout">Checkout →</a>
        <a class="lwacart-edit" href="/cart">edit on the cart page →</a>
      </div>` : ''}`;
  }

  const refresh = () => api('/cart.js').then(c => { CART = c; render(); }).catch(() => render());

  fab.addEventListener('click', () => { dr.classList.add('open'); scrim.classList.add('open'); refresh(); });
  const close = () => { dr.classList.remove('open'); scrim.classList.remove('open'); };
  scrim.addEventListener('click', close);
  dr.addEventListener('click', e => {
    if (e.target.closest('[data-x]')) return close();
    const dec = e.target.closest('[data-dec]'), inc = e.target.closest('[data-inc]'), rm = e.target.closest('[data-rm]');
    let line = null, qty = null;
    if (dec){ line = +dec.dataset.dec + 1; qty = Math.max(1, CART.items[line-1].quantity - 1); }
    if (inc){ line = +inc.dataset.inc + 1; qty = CART.items[line-1].quantity + 1; }
    if (rm){ line = +rm.dataset.rm + 1; qty = 0; }
    if (line) api('/cart/change.js', { line, quantity: qty }).then(c => { CART = c; render(); });
  });

  window.LWA_CARTDRAWER = {
    refresh,
    open: () => { dr.classList.add('open'); scrim.classList.add('open'); refresh(); },
    add: (id, qty) => api('/cart/add.js', { items: [{ id: +id, quantity: qty || 1 }] }).then(refresh)
  };
  refresh();
})();
